import client from 'libs/client';
import { TeamsheetPlayerData } from 'types/apiManagement';
import { TeamsheetPlayerSchema } from '../../types/apiManagement/schemas';

export interface TransformedTeamsheet {
  homeTeamPlayers: TeamsheetPlayerData[];
  awayTeamPlayers: TeamsheetPlayerData[];
}

export function useTeamsheet(taskId: string) {
  const query = client.getTeamsheet.useQuery(
    { id: parseInt(taskId) },
    {
      queryKey: ['teamsheet', taskId],
      enabled: !!taskId,
    }
  );

  const transformedTeamsheet: TransformedTeamsheet = {
    homeTeamPlayers: [],
    awayTeamPlayers: []
  };

  const rawPlayers = query.data?.data?.players || [];
  
  const players: TeamsheetPlayerData[] = rawPlayers.map(player => {
    const parsed = TeamsheetPlayerSchema.parse(player);
    return parsed as TeamsheetPlayerData;
  });

  if (players.length > 0) {
    const filteredHomePlayers = players.filter(player => player.data.provider.team === 'home');
    transformedTeamsheet.homeTeamPlayers = filteredHomePlayers;

    const filteredAwayPlayers = players.filter(player => player.data.provider.team === 'away');
    transformedTeamsheet.awayTeamPlayers = filteredAwayPlayers;
  }

  return {
    teamsheetData: players,
    transformedTeamsheet,
    isTeamsheetLoading: query.isLoading,
    refetch: query.refetch
  };
} 